"use strict";
/**
 * What a refused publish tells the editor: which field of which step keeps
 * the workflow from being published, in a form the editor words in the
 * person's language. The English `violations` next to it stay for logs and
 * for the assistant.
 *
 * Testing a step of the draft is refused in the same form when a finding
 * lies on the way to that step.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKFLOW_STRUCTURE_RULES = exports.WORKFLOW_PUBLISH_ISSUE_KINDS = exports.WORKFLOW_PREVIEW_REFUSED_CODE = exports.WORKFLOW_PUBLISH_REFUSED_CODE = void 0;
exports.isWorkflowPublishRefusal = isWorkflowPublishRefusal;
/** `code` of a publish refusal that carries `issues`. */
exports.WORKFLOW_PUBLISH_REFUSED_CODE = 'WORKFLOW_PUBLISH_REFUSED';
/** `code` of a refused step test of the draft; same body as a publish. */
exports.WORKFLOW_PREVIEW_REFUSED_CODE = 'WORKFLOW_PREVIEW_REFUSED';
exports.WORKFLOW_PUBLISH_ISSUE_KINDS = [
    /** A required input has neither a value nor a step that supplies it. */
    'input-unconnected',
    /** A required setting is empty. */
    'setting-empty',
    /** A typed value does not fit the format its field declares. */
    'value-format',
    /** A picked entry is not on the list the publishing person may choose from. */
    'selection-unavailable',
    /** A workflow output field gets no value from the End step. */
    'output-unmapped',
    /** A value does not fit the type or the choices of its field. */
    'value-invalid',
    /** A connection points at a step or a field that does not exist. */
    'mapping-invalid',
    /** The AI model chosen in a step cannot be used in the workspace. */
    'model-unavailable',
    /** A step still holds a secret of its own instead of a connection. */
    'credential-legacy',
    /** A step uses a connection the publishing person may not use. */
    'credential-unusable',
    /** The type of a newly added step is not available in the workspace. */
    'step-type-unavailable',
    /** A step changes outputs its type does not let anyone change. */
    'outputs-not-editable',
    /** The steps and connections do not form a workflow that can run. */
    'structure-invalid',
    /** The workflow exceeds the plan of the workspace. */
    'plan-limit',
];
/** What is wrong with the steps and connections as a whole. */
exports.WORKFLOW_STRUCTURE_RULES = [
    'empty',
    'start-missing',
    'end-missing',
    'id-missing',
    'id-duplicate',
    'edge-invalid',
    'branch-without-merge',
    'merge-without-branch',
    'loop-without-continue',
    'loop-without-exit',
    'loop-limit',
    'cycle',
];
/** Whether a response body is a refusal that names its issues. */
function isWorkflowPublishRefusal(body) {
    if (!body || typeof body !== 'object')
        return false;
    const candidate = body;
    return ((candidate['code'] === exports.WORKFLOW_PUBLISH_REFUSED_CODE ||
        candidate['code'] === exports.WORKFLOW_PREVIEW_REFUSED_CODE) &&
        Array.isArray(candidate['issues']));
}
